/**
 * Fisher-Yates shuffle for turn order.
 */
export function shuffleTurnOrder(memberIds) {
  const arr = [...memberIds];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/**
 * Get the next turn info given current state.
 * @returns {{ nextDrawerId, nextIndex, newRound, isGameOver }}
 */
export function getNextTurn(turnOrder, currentDrawerId, round, totalRounds) {
  const currentIndex = turnOrder.indexOf(currentDrawerId);
  const nextIndex = currentIndex + 1;

  // Check if we've completed all turns
  const totalTurns = turnOrder.length * totalRounds;
  const currentTurnNumber = (round - 1) * turnOrder.length + currentIndex + 1;

  if (currentTurnNumber >= totalTurns) {
    return { nextDrawerId: null, nextIndex: -1, newRound: round, isGameOver: true };
  }

  const nextDrawerIndex = nextIndex % turnOrder.length;
  const newRound = nextDrawerIndex === 0 ? round + 1 : round;

  return {
    nextDrawerId: turnOrder[nextDrawerIndex],
    nextIndex: nextDrawerIndex,
    newRound,
    isGameOver: false,
  };
}

/**
 * Calculate the sequential turn index (0-based) for tagging strokes.
 * Used in Relay Mode so strokes can be filtered by turn for playback.
 */
export function calculateTurnIndex(game) {
  if (!game || !game.turnOrder || !game.currentDrawerId) return 0;
  const posInOrder = game.turnOrder.indexOf(game.currentDrawerId);
  return ((game.round - 1) * game.turnOrder.length) + posInOrder;
}

/**
 * Build the full turn schedule for display.
 * @returns {Array<{ turnNumber, userId, round }>}
 */
export function buildTurnSchedule(turnOrder, totalRounds) {
  const schedule = [];
  for (let r = 1; r <= totalRounds; r++) {
    for (let i = 0; i < turnOrder.length; i++) {
      schedule.push({
        turnNumber: schedule.length + 1,
        userId: turnOrder[i],
        round: r,
      });
    }
  }
  return schedule;
}
